function EduTest(test){
    if (test) {
        this.wrapper = test;
        //this.testId = undefined;
        //this.repeatable = undefined;
        this.startDate = undefined;
        this.init();
        return this;
    }
}


EduTest.prototype = {
    init: function(){
        this.limitInput = this.wrapper.querySelector('[name=timeLimit]');
        this.limited = !!this.limitInput;

        //if (this.wrapper.querySelector('[name=testId]'));
        //this.testId = this.wrapper.querySelector('[name=testId]').value;
        //this.repeatable = JSON.parse(this.wrapper.querySelector('[name=testRepeat]').value);

        this.submitBtn = this.wrapper.querySelector('.submit-btn');
        this.fieldsets = this.wrapper.querySelectorAll('fieldset');
        this.requiredAnswers = this.wrapper.querySelectorAll('.form-row--required')
        this.form = this.wrapper.querySelector('form');
        this.errorsCounter = 0;

        if (this.limited) {
            this.endDate = parseInt(this.limitInput.value); //проверяем и записываем дату окончания теста
            this.timeLimit = parseInt(this.limitInput.value);
            this.countdowns = this.wrapper.querySelectorAll('.countdown');
            this.startTest();
        }

        /*Валидация и отправка*/
        if (this.submitBtn)
            this.submitBtn.addEventListener('click', this.submitHandler.bind(this));

        return this;
    },

    submitHandler: function(e){
        e.preventDefault();
      var valid = this.validateForm();
      if (valid)
          this.form.submit();
    },

    startTest: function(){
        var endDate = this.timeLimit;

        var testInstance = this;

        //console.log(Date.now() + 60 * 1000);
        if (endDate > Date.now()) { //если время финиша теста не превышено, запускаем тест
            var $cd = $(this.countdowns);

            $cd.each(function(){
               var $countdown = $(this);
               if ($countdown.is(':visible')) {
                   $countdown.countdown(endDate, function(event) {
                       var format = timerLgFormat;
                       if (event.offset.days < 1)
                           format = timerShortFormat;
                        if (typeof format !== 'undefined')
                            $(this).html(event.strftime(format));
                   }).on('finish.countdown', testInstance.blockTest.bind(testInstance));
               }
            });

        }
        else { //если время превышено, проверяем
            this.blockTest();
        }
    },
    /*Обработчик окончания времени теста*/
    blockTest: function(){
        $(this.countdowns).text('Время истекло');
        var valid = this.validateForm();

        this.submitBtn.disabled = true;

        var form = this.form;
        setTimeout(function(){
      //      form.submit();
        },3000);
    },

    validateForm: function(){
        this.errorsCounter = 0;
        var emptyFields = [];
        for (var i = 0; i < this.requiredAnswers.length; i++) {
            var invalid = this.checkValidity(this.requiredAnswers[i]);
            if (invalid) {
                var inputName = this.requiredAnswers[i].querySelector('input').name;
                emptyFields.push(inputName);
            }
        }

        this.emptyFields = emptyFields; //записываем названия неотвеченных вопросов
    //    this.emptyAnswersInput.value = emptyFields; //добавляем список неотвеченных вопросов в скрытый инпут
        return this.errorsCounter < 1
    },

    checkValidity: function(inputGroup) {
        var groupResult = false,
            inputs = inputGroup.querySelectorAll('input');
        var message = "Вы забыли ответить на этот вопрос",
            type = inputs[0].getAttribute('type');

        var errorsFields = [];

        for (var cnt = 0; cnt < inputs.length; cnt++) {
            var validity = inputs[cnt].validity;
            switch (type){
                case "radio":
                    if (validity.valueMissing) {
                        groupResult = true;
                    }
                break;
                case "checkbox":

                    if (validity.valueMissing) {
                        groupResult = true;
                        message = "Вы забыли ответить на этот вопрос";
                    }
                    else {
                        cnt = inputs.length;
                        groupResult = false;
                    }
                    break;
                default:
                    break;
            }
        }

        if (groupResult) {
            var errorData = {
                question: inputGroup,
                message: message
            };
            this.errorsCounter = this.errorsCounter + 1;
            this.showError(errorData);
        }
        else {
            this.cleanError({question: inputGroup});
        }

        return groupResult;
    },
    /**отображение ошибки
     * @param {domNode} data.question - вопрос, рядом который помечать ошибкой
     * @param {string} data.message - текст сообщения об ошибке
     * */
    showError: function(data){
        var errorWrapper = data.question.querySelector('.form-row__errors');
        errorWrapper.innerHTML = "<span class='alert alert-danger'>" + data.message + "</span>"
    },
    cleanError: function(data){
        var errorWrapper = data.question.querySelector('.form-row__errors');
        errorWrapper.innerHTML = '';
    }
}


document.addEventListener('DOMContentLoaded', function(){

    var tfLg = document.getElementById('long-countdown-limit'); //формат таймера
    var tfShort = document.getElementById('short-countdown-limit'); //формат таймера
    if (tfLg)
        window.timerLgFormat = tfLg.innerHTML;
    if(tfShort)
        window.timerShortFormat = tfShort.innerHTML;

    var testForms = document.querySelectorAll('.test-form');
   if (testForms.length) {
       for(var i = 0; i < testForms.length; i++) {
           var tf = new EduTest(testForms[i]);
       }
   }
});

$(function(){
    /*Счетчики на странице с видеоуроками*/
   var $lessonsCountdowns = $('.countdown-lesson');

    $lessonsCountdowns.each(function(){
       var $this = $(this),
           limit = $this.data('limit');

       if (limit && $this.is(':visible') && timerLgFormat) {
           $this.countdown(limit, function(event) {
               var format = timerLgFormat;
               if (event.offset.days < 1 && event.offset.weeks < 1)
                   format = timerShortFormat;

               if (typeof format !== 'undefined')
                   $(this).html(event.strftime(format));
           });
       }
   });
});